// HospiceComfortSection.js
import React from "react";
import { Phone } from "lucide-react";
import hospiceComfortImage from "../assets/hospice-comfort-image.jpg";

const HospiceComfortSection = () => {
  return (
    <section className="py-16 px-6 md:px-12 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Hospice Care for Comfort, Dignity, and Family Support
            </h2>

            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-8">
              <p>
                At Allawah Lodge, we believe hospice care should bring peace and
                presence to both patients and families. Our team focuses on
                creating a calm and supportive environment where individuals can
                remain in the place they love most — home. Through compassionate
                assistance, emotional support, and specialised attention, our
                caregivers ensure that comfort and dignity are always at the
                centre of care.
              </p>

              <p>
                Hospice care is more than medical support — it's about
                preserving quality of life in meaningful ways. Our caregivers
                work alongside families, offering gentle help with daily
                routines, companionship, and relief for primary caregivers. We
                understand how sensitive this time can be, which is why every
                visit is guided by empathy, respect, and the goal of making each
                moment as peaceful as possible.
              </p>
            </div>

            <a
              href="tel:+61269272706"
              className="inline-flex items-center gap-2 bg-[#E85D2C] hover:bg-[#d54d1f] text-white font-medium px-6 py-3 rounded-full transition-colors"
            >
              <Phone size={20} />
              CALL: (02) 6927 2706
            </a>
          </div>

          {/* Right Image */}
          <div>
            <img
              src={hospiceComfortImage}
              alt="Caregiver assisting elderly woman"
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HospiceComfortSection;
